/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
/**
 * enumeration of all internal capability names
 */
export var CapNames;
(function (CapNames) {
    CapNames["SKYBOX"] = "_skybox";
    CapNames["LIGHT"] = "_light";
    CapNames["TEXT3D"] = "_text3d";
    CapNames["AXIS"] = "_axisHelper";
    CapNames["OBJFILE"] = "_objFile";
    CapNames["STLFILE"] = "_stlFile";
    CapNames["GRID"] = "_grid";
    CapNames["STOREACTOR"] = "_storeActor";
    CapNames["ACTOR"] = "_actor";
    CapNames["GENERICSOLID"] = "_genericSolid";
    CapNames["FLOOR"] = "_floor";
})(CapNames || (CapNames = {}));
//# sourceMappingURL=CapNames.js.map